import { useState, useCallback, useEffect } from 'react';
import { Box, Checkbox, FormControlLabel, makeStyles, Typography } from '@material-ui/core';
import moment from 'moment';
import * as Yup from 'yup';
import { bedStatusAPI } from '../../../../../apis';
import { i18n } from '../../../../../language';
import { KeyboardTimeInput } from '../../../../../components';
import { checkSubmitData } from '../../../../../utils/check';
import Text from '../../../../../components/Text';

const useStyles = makeStyles((theme) => ({
  root: {
    height: '80%',
    flex: '1',
    display: 'flex',
    background: '#fff',
    padding: '1.875rem',
    borderRadius: '0 0.93rem 0.93rem 0.93rem',
    flexDirection: 'column',
  },
  checkBox: {
    '& .MuiCheckbox-root': {
      color: '#c0c6cb',
    },
    '& .MuiTypography-root': {
      fontFamily: 'NotoSans-Medium',
      fontSize: '1rem',
      fontWeight: '500',
      color: '#2e4469',
    },
    '& .Mui-checked': {
      color: '#28d2ab',
    },
  },
  divider: {
    height: '1px',
    width: '100%',
    background: '#E4E7EB',
    margin: '24px 0',
  },
  keyboardTimeInput: {
    paddingRight: '0',
    '& .MuiFormControl-root': {
      display: 'flex',
      justifyContent: 'center',
    },
  },
  errorMsg: {
    margin: '3px 0.825rem 0 2.1rem',
    color: '#f44336',
    fontFamily: 'NotoSans-Medium',
    fontWeight: '500',
  },
}));
export default function TransferIn() {
  const classes = useStyles();
  const [checkBox, setCheckBox] = useState(false);
  const [defaultTime, setDefaultTime] = useState(null);
  const [enableDefaultTime, setEnableDefaultTime] = useState(false);
  const getYupScheme = (enableDefaultTime) => {
    return {
      defaultTime: enableDefaultTime
        ? Yup.date()
            .required(i18n.t('SETTING_IS_A_REQUIRED_FIELD', { value: i18n.t('BEDSTATUS_TIME') }))
            .typeError(i18n.t('BEDSTATUS_INVALID_DATE_FORMAT'))
        : Yup.date().nullable(),
    };
  };

  const [errorMsg, setErrorMsg] = useState({ defaultTime: '' });
  const transferEnableDetail = useCallback(async () => {
    try {
      const { result } = await bedStatusAPI.getTransferEnabledetail();
      setCheckBox(result.enableYn);
    } catch (error) {}
  }, []);
  const transferEnableUpdate = useCallback(async (checked) => {
    try {
      await bedStatusAPI.postTransferEnableUpdate({ enableYn: checked });
    } catch (error) {}
  }, []);
  const onChangeHandle = (event) => {
    setCheckBox(event.target.checked);
    let enableYn;
    if (event.target.checked) {
      enableYn = 1;
    } else {
      enableYn = 0;
    }
    transferEnableUpdate(enableYn);
  };
  const updateDefaultAdmissionTime = async (defaultTime) => {
    try {
      await bedStatusAPI.updateDefaultAdmissionTime({
        transferTime: defaultTime ? defaultTime.format('HH:mm:ss') : null,
      });
    } catch (error) {
      console.log(error);
    }
  };
  const changeDefaultTime = async (event, enableDefaultTime = false) => {
    const scheme = getYupScheme(enableDefaultTime);

    try {
      await checkSubmitData(Yup.object().shape(scheme), { defaultTime: event });
      setErrorMsg({ defaultTime: '' });
      setDefaultTime(event);
      updateDefaultAdmissionTime(event);
    } catch (e) {
      setErrorMsg({ ...e });
    }
  };
  const getDefaultAdmissionTime = useCallback(async () => {
    try {
      const { result } = await bedStatusAPI.getDefaultAdmissionTime();
      const defaultTime = result?.transferTimeDefault ? moment(result?.transferTimeDefault, 'HH:mm:ss') : null;
      setEnableDefaultTime(Boolean(result?.transferTimeDefault));
      setDefaultTime(defaultTime);
    } catch (error) {
      console.log(error);
    }
  }, []);
  const changeEnableDefaultTime = (event) => {
    setEnableDefaultTime(event.target.checked);
    if (!event.target.checked) {
      changeDefaultTime(null, event.target.checked);
    }
  };

  useEffect(() => {
    transferEnableDetail();
    getDefaultAdmissionTime();
  }, [transferEnableDetail, getDefaultAdmissionTime]);

  return (
    <div className={classes.root}>
      <Box>
        <FormControlLabel
          id="bed_occupieddischarge_home_leave"
          control={<Checkbox />}
          label={i18n.t('BEDSTATUS_ENABLE_REVCEIVING_TRANSFER_IN')}
          className={classes.checkBox}
          checked={Boolean(checkBox)} // 3.
          onChange={onChangeHandle}
        />
      </Box>
      <Box className={classes.divider} />
      <Box>
        <Text fontSize="1.142rem" fontWeight={500} color="#2E4469" mb={10}>
          Default admission time at transfer in request form
        </Text>
        <FormControlLabel
          id="bed_occupieddischarge_home_leave"
          control={<Checkbox />}
          label={
            <Box width={320}>
              <KeyboardTimeInput
                id="bed_default_admission_time"
                className={classes.keyboardTimeInput}
                value={defaultTime}
                placeholder={i18n.t('BEDSTATUS_SELECT_TIME')}
                onChange={async (event) => {
                  await changeDefaultTime(event);
                }}
                disabled={!enableDefaultTime}
              />
            </Box>
          }
          className={classes.checkBox}
          checked={enableDefaultTime}
          onChange={changeEnableDefaultTime}
        />
        {!moment(defaultTime).isValid() && errorMsg && (
          <Typography className={classes.errorMsg}>{errorMsg?.defaultTime}</Typography>
        )}
      </Box>
    </div>
  );
}
